import React from 'react';
import TrueImpactLevelFeedbackBox from 'shared/design-system/components/TrueImpactLevelFeedbackBox';
import { BudgetFlag, IRS_SOURCE_TEXT } from './budgetFlagUtils';

interface BudgetFlagBoxProps {
  flag: BudgetFlag;
  // Explanation already saved on the report; when present the box is
  // informational only and no longer blocks Save & Continue.
  note?: string | null;
  onExplain: () => unknown;
}

const BudgetFlagBox: React.FC<BudgetFlagBoxProps> = ({
  flag,
  note,
  onExplain,
}) => {
  return (
    <TrueImpactLevelFeedbackBox
      severity={flag.severity}
      title={flag.title}
      message={flag.message}
      sourceText={IRS_SOURCE_TEXT}
      note={note}
      onExplain={onExplain}
    />
  );
};

export default BudgetFlagBox;
